import { baseApi } from "./baseApi";

export const uploadAttachmentApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    uploadAttachment: builder.mutation({
      query: ({ formData }) => {
        console.log("attachment Mutation");
        for (let [key, value] of formData.entries()) {
          console.log(key, value);
        }
        return {
          url: `upload-attachments`,
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadAttachmentMutation } = uploadAttachmentApi;
